/** Keep upstream product branding out of application-facing messages. */
export function genericApplicationMessage(message: string): string {
  return message.replace(/\bsolution[ \t]+studio(?:['’]s)?\b[ \t]*/gi, '').trim();
}
